// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__lKGd6","inside":"Circle_inside__G+1ZH"};